import { render, staticRenderFns } from "./PrevButton.vue?vue&type=template&id=19841a16&"
import script from "./PrevButton.vue?vue&type=script&lang=js&"
export * from "./PrevButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19841a16')) {
      api.createRecord('19841a16', component.options)
    } else {
      api.reload('19841a16', component.options)
    }
    module.hot.accept("./PrevButton.vue?vue&type=template&id=19841a16&", function () {
      api.rerender('19841a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PrevButton.vue"
export default component.exports